document.getElementById("cancelBtn").addEventListener("click", () => {
    // console.log("Cancel clicked");
    document.getElementById("searchForm").classList.remove("visible");
});

document.getElementById("searchBtn").addEventListener("click", () => {
    // console.log("Search clicked");
    document.getElementById("searchForm").classList.add("visible");
});